
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getByCheck, getInfo, OfficialDocData, emptyData } from '@/api/officialDoc/doc'
import { tryToInt, newGuid } from '@/configs/functions'
import { enFirstType } from '@/configs/enums'
import { DDLItem, getOfficialDocTypes, getOfficialDocYears } from '@/api/common/select'

@Component
export default class DocSelector extends Vue {
  //@docChange="getDoc" getDoc(data:{ Id: number, Ref: string })
  @Prop({ default: 0 })
  public docId!: number
  //控件标识，在页面中多次使用时，通过refTo来判断
  @Prop({ default: '' })
  public refTo: string = ''

  public loading: boolean = false
  public typeList: DDLItem[] = []
  public yearList: DDLItem[] = []
  public guid: string = ''
  public form: OfficialDocData = Object.assign({}, emptyData)
  public docType: number = 0
  public docYear: number = 0
  public docNo: string = ''
  get msg(): string {
    let m = ''
    const f = this.form
    if (f.Id > 0) {
      m = f.CategoryName + ':' + f.DocCompileNo + ' ' + f.DocTitle
    }
    return m
  }
  public checkDoc() {
    if (this.docType > 0 && this.docYear > 0 && this.docNo != '') {
      this.form.DocType = this.docType
      this.form.DocYear = this.docYear.toString()
      this.form.DocSerialNo = this.docNo
      this.fetchDoc(false)
    }
  }
  public fetchDoc(byId: boolean) {
    this.loading = true
    if (byId) {
      getInfo(this.docId).then((response: { data: any }) => {
        this.form = response.data
        this.docType = this.form.DocType
        this.docYear = tryToInt(this.form.DocYear)
        this.docNo = this.form.DocSerialNo
        this.loading = false
      })
    }
    else {
      let f = this.form
      getByCheck(f.DocType, f.DocYear, f.DocSerialNo).then((response: { data: any }) => {
        f = response.data
        this.loading = false
        if (f.Id == 0) {
          this.$confirm('该批文不存在，是否要新增？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.guid = newGuid()
            const opt = {
              DocType: this.docType,
              DocYear: this.docYear,
              DocNo: this.docNo,
              AttachType: f.AttachType,
              AttachGuid: f.AttachGuid,
              targetId: this.guid
            }
            window.eventBus.$emit('openOfficialDocForm', opt)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
            // this.form = Object.assign({}, emptyData)
            // this.docType = 0
            // this.docYear = 0
            this.form.DocSerialNo = this.docNo = ''
          })
        }
        else {
          this.form = f
          this.getDoc()
        }
      })
    }
  }
  public getDoc() {
    this.$emit('docChange', { data: this.form, refTo: this.refTo })
  }
  public mounted() {
    window.eventBus.$on('submitOfficialDocForm', (info: { targetId: string, data: OfficialDocData }) => {
      if (this.guid === info.targetId) {
        this.form = Object.assign({}, info.data)
        this.getDoc()
      }
    })
    window.eventBus.$on('cancelOfficialDocForm', (info: { targetId: string }) => {
      if (this.guid === info.targetId) {
        this.form.DocSerialNo = this.docNo = ''
      }
    })
    this.fetchSource()
    this.$nextTick(() => {
      if (this.docId > 0) {
        this.fetchDoc(true)
      }
    })

    //延迟查询
    // setTimeout(() => {
    //   console.log('setTimeout', new Date(), this.docId)
    //   if (this.docId > 0) {
    //     this.fetchDoc(true)
    //   }
    // }, 50)
  }
  public beforeDestroy() {
    window.eventBus.$off('submitOfficialDocForm')
    window.eventBus.$off('cancelOfficialDocForm')
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.typeList.length === 0) {
      //category 0.所有批文 1.立项批文Resvered_Flag1=true，2.批复/意见文号(Resvered_Flag2=true 冀文物发、文物保函、办保函)
      const category = 0
      getOfficialDocTypes(category, firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.typeList = data
        }
      })
    }
    if (this.yearList.length === 0) {
      getOfficialDocYears(firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.yearList = data
        }
      })
    }
  }
}
